import UrlUtils from "../../utils/url.es6";
import ApiClient from "../../modules/api.es6";

const API_URL = "./api/news.php";

export default class NewsList {
    constructor() {
        this.isTop = document.body.classList.contains("top");

        this.itemsPerPage = this.isTop ? 3 : 6;
        this.current = 1;
        this.total = 0;
        this.query = {};
        this.items = [];

        this._init();
    }

    _init() {
        this.query = UrlUtils.getQuery();
        this.api = new ApiClient(this.isTop ? API_URL : "." + API_URL);
        this.current = parseInt(this.query.page) || 1;

        // acms_loaderが読み込まれるまで待機
        if (typeof window.acms_loader !== "undefined") {
            this._loadJson();
        } else {
            // 読み込み待機
            setTimeout(() => this._init(), 100);
        }
    }

    async _loadJson() {
        // acms_loaderのコールバックを設定
        window.acms_loader.ready = (json) => {
            this._parseJson(json);
            this._displayItems();
            this._filterItemsByTag(this.query.tag || "all");
        };

        // API呼び出し開始
        window.acms_loader.start();
    }

    _parseJson(json) {
        //console.log(json);

        if (!json || !Array.isArray(json)) {
            console.error("_parseJson: jsonが配列ではありません", json);
            return;
        }

        for (let i = 0; i < json.length; i++) {
            const data = {};
            data.id = json[i].id;
            data.title = json[i].title_html;
            data.date = this._formatDate(json[i].date);
            data.isNew = parseInt(json[i].newflg);
            data.content = json[i].content_html;

            const tagRegex = /#tag:([a-zA-Z0-9,]+)/;
            const match = data.content.match(tagRegex);
            if (match) {
                data.tag = match[1].trim().toUpperCase(); // タグを抽出
                data.tags = match[1].split(",").map((t) => t.trim()); // タグを配列に分解
                data.content = data.content.replace(tagRegex, ""); // タグを本文から削除
            } else {
                data.tags = [];
            }

            this.items.push(data);
        }
    }

    _formatDate(dateStr) {
        const options = {
            year: "2-digit",
            month: "2-digit",
            day: "2-digit",
        };

        const formatter = new Intl.DateTimeFormat("en-US", options);
        const date = new Date(dateStr);
        const parts = formatter.formatToParts(date);

        const year = parts.find((p) => p.type === "year").value;
        const month = parts.find((p) => p.type === "month").value;
        const day = parts.find((p) => p.type === "day").value;

        return `20${year}.${month}.${day}`;
    }

    _displayItems() {
        this.total = Math.ceil(this.items.length / this.itemsPerPage); // フィルタリング後のページ数を更新
        this._updatePager();
        this._createListHTML(this.items.slice((this.current - 1) * this.itemsPerPage, this.current * this.itemsPerPage));
    }

    _createListHTML(items = this.items) {
        let htmlstr = "";

        if (items && items.length) {
            const devStr = this.query.dev === "1" ? "&dev=1" : "";
            const path = this.isTop ? "./news/" : "./";
            for (let i = 0; i < items.length; i++) {
                const item = items[i];
                htmlstr += `<div class="newslist__item">
                    <a class="c-hover_op newslist__item__link" href="${path}detail.php?id=${item.id + devStr}">
                        <div class="newslist__item__cont">
                            <p class="newslist__item__date">${item.date}</p>
                            <p class="newslist__item__title">${item.title}</p>
                        </div>
                    </a>
                </div>`;
            }
        } else {
            htmlstr += '<p class="newslist__item__empty">現在、お知らせはありません。</p>';
        }

        document.querySelector(".js-newslist__list").innerHTML = htmlstr;
        document.body.classList.add("-newsready");
    }

    _filterItemsByTag(tag) {
        const filteredItems = this.items.filter((item) => tag === "all" || item.tags.includes(tag));
        this.total = Math.ceil(filteredItems.length / this.itemsPerPage); // フィルタリング後のページ数を更新

        this._updatePager();
        this._createListHTML(filteredItems.slice((this.current - 1) * this.itemsPerPage, this.current * this.itemsPerPage));
    }

    _updatePager() {
        if (this.isTop) return;
        if (1 >= this.total) return;

        let pagerHtml = `<div class="newslist__pager c-font__acumin"><div class="newslist__pager__inner">`;
        const baseLink = `./?${this.query.dev ? "dev=1&" : ""}page=`;
        const prevLink = this.current > 1 ? `${baseLink}${this.current - 1}` : `${baseLink}1`;
        const nextLink = this.current < this.total ? `${baseLink}${this.current + 1}` : `${baseLink}${this.total}`;
        const pages = this._generatePageNumbers();

        pagerHtml += `<p class="newslist__pager__arrow -prev${this.current === 1 ? " -disabled" : ""}">
            <a class="c-arw -prev c-hover_op" href="${prevLink}"></a>
        </p>`;

        pages.forEach((page) => {
            if (page === "ellipsis") {
                pagerHtml += `<span class="newslist__pager__ellipsis">...</span>`;
            } else {
                pagerHtml += `<div class="newslist__pager__num${this.current === page ? " -active" : ""}">
                    ${this.current === page ? `<span>${page}</span>` : `<a href="${baseLink}${page}">${page}</a>`}
                </div>
            `;
            }
        });

        pagerHtml += `<p class="newslist__pager__arrow -next${this.current === this.total ? " -disabled" : ""}">
            <a class="c-arw -next c-hover_op" href="${nextLink}"></a>
        </p>`;

        pagerHtml += `</div></div>`;

        document.querySelector(".js-newslist__pager").innerHTML = pagerHtml;
    }

    _generatePageNumbers() {
        if (this.total <= 6) {
            return Array.from({ length: this.total }, (_, i) => i + 1);
        }

        let pages = [];

        if (this.current <= 4) {
            pages = [...Array.from({ length: 5 }, (_, i) => i + 1), "ellipsis", this.total];
        } else if (this.current >= this.total - 3) {
            pages = [1, "ellipsis", ...Array.from({ length: 5 }, (_, i) => this.total - 4 + i)];
        } else {
            pages = [1, "ellipsis", this.current - 1, this.current, this.current + 1, "ellipsis", this.total];
        }

        return pages;
    }
}
